import styled from 'styled-components/native';
import {RFValue} from 'react-native-responsive-fontsize';
import Feather from 'react-native-vector-icons/Feather';
import FastImage from 'react-native-fast-image';
import MapView from 'react-native-maps';

export const Section = styled.View`
  margin-top: ${RFValue(12)}px;
  padding: 0 24px;
  border-top-width: 1px;
  border-top-color: ${({theme}) => theme.colors.border};
  margin-top: ${RFValue(16)}px;
  padding-top: ${RFValue(16)}px;
`;

export const SectionTitle = styled.Text`
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(14)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
`;

export const StationCard = styled.View`
  margin-top: ${RFValue(12)}px;
`;

export const StationMapButton = styled.TouchableOpacity`
  border-radius: ${RFValue(12)}px;
  overflow: hidden;
   margin-bottom: ${RFValue(12)}px;
`;

export const StationMap = styled(MapView)`
  height: ${RFValue(130)}px;
  border-radius: ${RFValue(12)}px;
  background: ${({theme}) => theme.colors.background_secondary};
`;

export const StationMarkerImage = styled(FastImage)`
  width: ${RFValue(30)}px;
  height: ${RFValue(30)}px;
  border-radius: ${RFValue(8)}px;
  border: 2px solid ${({theme}) => theme.colors.image_border};
`;

export const StationInfosRow = styled.TouchableOpacity`
 
  flex-direction: row;
  align-items: center;
`;

export const StationInfosContainer = styled.View`
  flex-direction: row;
  align-items: center;
  flex: 1;
`;

//@ts-ignore
export const StationImage = styled(FastImage)`
  width: ${RFValue(32)}px;
  height: ${RFValue(32)}px;
  border-radius: ${RFValue(8)}px;
  border: 2px solid ${({theme}) => theme.colors.image_border};
`;

export const StationInfos = styled.View`
  margin-left: ${RFValue(10)}px;
`;

export const StationTitle = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(12)}px;
`;

export const StationDescription = styled.Text`
  font-family: ${({theme}) => theme.fonts.regular};
  color: ${({theme}) => theme.colors.text};
  font-size: ${RFValue(10)}px;
`;

export const StationMapIcon = styled(Feather)`
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(14)}px;
`;

export const LinkButtonContainer = styled.View`
  flex-direction: row;
  margin-top: ${RFValue(12)}px;
  align-items: flex-start;
`;

export const MapSheetContainer = styled.View`
  padding: 0 24px;
`;

export const MapSheetTitle = styled.Text`
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(14)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
  margin-bottom: ${RFValue(12)}px;
`;

export const MapSheetOption = styled.TouchableOpacity`
  flex-direction: row;
  align-items: center;
  padding: ${RFValue(10)}px 0;
  border-top-width: 1px;
  border-top-color: ${({theme}) => theme.colors.border};
`;

export const MapSheetOptionIcon = styled.Image`
  width: ${RFValue(32)}px;
  height: ${RFValue(32)}px;
  border-radius: ${RFValue(8)}px;
`;

export const MapSheetOptionText = styled.Text`
  margin-left: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(13)}px;
  font-family: ${({theme}) => theme.fonts.medium};
`;

